var Color;
(function (Color) {
    Color["WHITE"] = "#FFFFFF";
    Color["PINK"] = "#FF3A67";
    Color["YELLOW"] = "#FBA72D";
    Color["GREEN"] = "#29A87C";
    Color["BLUE_1"] = "#F0FBFF";
    Color["BLUE_2"] = "#CFEBF6";
    Color["BLUE_3"] = "#64C2E7";
    Color["BLUE_4"] = "#0096D6";
    Color["BLUE_5"] = "#007BC7";
    Color["BLUE_6"] = "#152F50";
    Color["GRAY_1"] = "#FAFAFA";
    Color["GRAY_2"] = "#F5F5F5";
    Color["GRAY_3"] = "#DEDEDE";
    Color["GRAY_4"] = "#B8B8B8";
    Color["GRAY_5"] = "#747474";
    Color["GRAY_6"] = "#333333";
})(Color || (Color = {}));
export default Color;
//# sourceMappingURL=color.js.map